import { fetchAssets, addAsset, deleteAsset, editAsset } from "../api/api";

export const addAssetFile = (data, navigate) => async (dispatch) => {
    try {
        dispatch({ type:"ASSET_UPLOAD_REQUEST" });

        const res = await addAsset(data);

        if (res.data.message === 'Filename already exist') {
            dispatch({
                type: 'ASSET_UPLOAD_FILE_EXISTS',
                payload: res.data.message
            });
        } else {
            dispatch({
                type: 'ASSET_UPLOAD_SUCCESS',
                payload: res.data
            });
        }

        return res.data;
    } catch (error) {
        console.log(error);
        dispatch({
            type: "ASSET_UPLOAD_FAIL",
            payload: error.response?.data?.message || "Something went wrong",
        })

    }
}

export const getAssets = (workspaceId) => async (dispatch) => {
    try {
        const res = await fetchAssets(workspaceId);
        dispatch({
            type: 'GET_ASSETS',
            payload: res.data.assets
        })

        return res.data.assets;
    } catch (err) {
        console.log(err);
    }
}

export const updateAsset = (id, data) => async (dispatch) => {
    try {
        dispatch({ type: "ASSET_UPDATE_REQUEST" });

        const res = await editAsset(id, data);

        dispatch({
            type: 'ASSET_UPDATE_SUCCESS',
            payload: res.data.assets
        });
        return true;
    } catch (error) {
        dispatch({
            type: "ASSET_UPDATE_FAIL",
            payload: error.response?.data?.message || "Something went wrong",
        });
        return false;
    }
}

export const removeAsset = (id) => async (dispatch) => {
    try {
        dispatch({ type: "ASSET_DELETE_REQUEST" });
        const res = await deleteAsset(id);

        dispatch({
            type: 'ASSET_DELETE_SUCCESS',
            payload: res.data
        });
        return true;
    } catch (error) {
        dispatch({
            type: "ASSET_DELETE_FAIL",
            payload: error.response?.data?.message || "Something went wrong",
        });
        return false;
    }
} 